import React, {Component} from 'react';
import classes from './DateIcon.module.scss'

class DateIcon extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.state = {
            done: undefined
            , my_list: [],
        }//end state
    }//end constructor

    render() {
        // console.log(this.props.created_on);
        const date = this.props.created_on.split(' ')[0];
        const dDay = date.split('-')[2];
        const dMonth = date.split('-')[1];
        const dYear = date.split('-')[0]
        return (
            <React.Fragment>
                <div className={[classes.Date_component, this.props.classMy].join(' ')}>
                    <div className={classes.NewsEvent_itemCalText}>
                        <span>{dDay}</span><br/>
                        <span>{dMonth +' ' +dYear}</span>
                    </div>
                </div>
            </React.Fragment>
        );
    }//end render()

    componentDidMount() {
        // console.log('[DateIcon.js] componentDidMount');
    }//end componentDidMount

}//end class function

export default DateIcon;